//# sourceMappingURL=font-type-configuration.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/fonts/font-type-configuration.interface.js
// module id = 1168
// module chunks = 4